import axios from "axios";
import instance from "../../../../axios";

export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const BASE_URL_V2 = `${process.env.REACT_APP_API_URL_V2}`;
export const LOCAL_URL = `${process.env.REACT_APP_API_URL_LOCAL}`;
export const UPLOAD_URL = `${process.env.REACT_APP_UPLOAD_URL}`;

export function getCompany(queryParams) {
  queryParams.pagination.optimized=true;
  return instance.post(`${BASE_URL}/company/list`, queryParams)
    .then(res => {
      return res;
    })
};

export function addCompany(queryParams) {
  return instance.post(`${BASE_URL}/company/add`, queryParams)
    .then(res => {
      return res;
    })
};



export function uploadImage(file) {
  let formData = new FormData();
  formData.append('file', file);
  return instance.post(`${UPLOAD_URL}`, formData);
}



export function updateCompany(queryParams) {
  return instance.post(`${BASE_URL}/company/update/${queryParams._id}`, queryParams)
    .then(res => {
      return res;
    })
};

export function deleteCompany(id) {
  return instance.post(`${BASE_URL}/company/delete/${id}`)
    .then(res => {
      return res;
    })
};

export function updateCompanyStatus(queryParams) {
  return instance.post(`${BASE_URL}/company/status/${queryParams._id}`, queryParams)
    .then(res => {
      return res;
    })
};

export function getAssignGameTypeList(companyId) {
  return instance.get(`${BASE_URL_V2}/gametype/assign/list/${companyId}`).then(res => {
    return res;
  });
}
export function getAssignGameTypeListOptimized(companyId) {
  return instance.get(`${BASE_URL_V2}/gametype/assigned/list/${companyId}`).then(res => {
    return res;
  });
}
export function assignGameType(body) {
  return instance.post(`${BASE_URL_V2}/gametype/assign/`, body).then(res => {
    return res;
  });
}

export function uploadGameImage(file) {
  let formData = new FormData();
  formData.append('file', file);
  let url = BASE_URL + '/image/upload'
  return instance.post(`${url}`, formData);
}

export function gameLogs(body) {
  return instance.post(`${BASE_URL}/moduleLog/get`, body).then(res => {
    return res;
  });
}